// HKDSE Mathematics Paper 3 - Remaining Questions (6-30)
// 香港中學文憑考試 數學科 試卷3 剩餘題目

export const paper3RemainingQuestions = [
  {
    id: 6,
    question: "一個標準骰子投擲兩次，兩次都得到偶數的概率是：",
    questionEn: "A standard die is rolled twice. The probability of getting even numbers both times is:",
    options: ["\\(\\frac{1}{4}\\)", "\\(\\frac{1}{2}\\)", "\\(\\frac{1}{3}\\)", "\\(\\frac{3}{4}\\)"],
    correctAnswer: 0,
    explanation: "偶數有2, 4, 6，每次得到偶數的概率是 \\(\\frac{3}{6} = \\frac{1}{2}\\)。兩次都是偶數的概率是 \\(\\frac{1}{2} \\times \\frac{1}{2} = \\frac{1}{4}\\)",
    explanationEn: "Even numbers are 2, 4, 6. Probability of even each time is \\(\\frac{3}{6} = \\frac{1}{2}\\). Probability of even both times is \\(\\frac{1}{2} \\times \\frac{1}{2} = \\frac{1}{4}\\)",
    difficulty: "easy",
    topic: "概率",
    hasMath: true
  },
  {
    id: 7,
    question: "數據集 {1, 3, 5, 7, 9, 11} 的變異數（方差）是：",
    questionEn: "The variance of the data set {1, 3, 5, 7, 9, 11} is:",
    options: ["\\(\\frac{35}{3}\\)", "\\(\\frac{35}{6}\\)", "\\(6\\)", "\\(\\sqrt{\\frac{35}{3}}\\)"],
    correctAnswer: 0,
    explanation: "平均數 \\(\\bar{x} = 6\\)，變異數 \\(\\sigma^2 = \\frac{\\sum(x_i - \\bar{x})^2}{n} = \\frac{(1-6)^2 + (3-6)^2 + ... + (11-6)^2}{6} = \\frac{70}{6} = \\frac{35}{3}\\)",
    explanationEn: "Mean \\(\\bar{x} = 6\\), variance \\(\\sigma^2 = \\frac{\\sum(x_i - \\bar{x})^2}{n} = \\frac{(1-6)^2 + (3-6)^2 + ... + (11-6)^2}{6} = \\frac{70}{6} = \\frac{35}{3}\\)",
    difficulty: "medium",
    topic: "變異性",
    hasMath: true
  },
  {
    id: 8,
    question: "在正態分佈中，約有多少百分比的數據落在平均數的一個標準差範圍內？",
    questionEn: "In a normal distribution, approximately what percentage of data falls within one standard deviation of the mean?",
    svgDiagram: `
      <svg width="300" height="200" viewBox="0 0 300 200">
        <path d="M 50 150 Q 150 50 250 150" fill="none" stroke="#3b82f6" stroke-width="3"/>
        <line x1="150" y1="50" x2="150" y2="180" stroke="#ef4444" stroke-width="2" stroke-dasharray="5,5"/>
        <line x1="100" y1="75" x2="100" y2="180" stroke="#10b981" stroke-width="2" stroke-dasharray="3,3"/>
        <line x1="200" y1="75" x2="200" y2="180" stroke="#10b981" stroke-width="2" stroke-dasharray="3,3"/>
        <text x="145" y="195" font-size="12" fill="#ef4444">μ</text>
        <text x="85" y="195" font-size="12" fill="#10b981">μ-σ</text>
        <text x="195" y="195" font-size="12" fill="#10b981">μ+σ</text>
        <path d="M 100 75 Q 150 50 200 75" fill="rgba(16, 185, 129, 0.3)" stroke="none"/>
        <text x="130" y="40" font-size="14" fill="#10b981">68%</text>
      </svg>
    `,
    options: ["約 68%", "約 95%", "約 99.7%", "約 50%"],
    correctAnswer: 0,
    explanation: "根據經驗法則（68-95-99.7法則），約68%的數據落在平均數的一個標準差範圍內",
    explanationEn: "According to the empirical rule (68-95-99.7 rule), approximately 68% of data falls within one standard deviation of the mean",
    difficulty: "medium",
    topic: "正態分佈",
    hasMath: false,
    hasSvg: true
  },
  {
    id: 9,
    question: "相關係數 r = 0.8 表示兩個變數之間存在：",
    questionEn: "A correlation coefficient r = 0.8 indicates that between two variables there is:",
    options: ["強正相關", "弱正相關", "強負相關", "無相關"],
    correctAnswer: 0,
    explanation: "相關係數 r = 0.8 接近 1，表示兩個變數之間存在強正相關關係",
    explanationEn: "Correlation coefficient r = 0.8 is close to 1, indicating a strong positive correlation between the two variables",
    difficulty: "easy",
    topic: "相關性",
    hasMath: false
  },
  {
    id: 10,
    question: "在假設檢驗中，α = 0.05 表示：",
    questionEn: "In hypothesis testing, α = 0.05 represents:",
    options: ["顯著性水準為 5%", "信心水準為 5%", "樣本大小為 5%", "檢驗力為 5%"],
    correctAnswer: 0,
    explanation: "α = 0.05 表示顯著性水準為 5%，即錯誤拒絕真實虛無假設的概率為 5%",
    explanationEn: "α = 0.05 represents a significance level of 5%, meaning the probability of incorrectly rejecting a true null hypothesis is 5%",
    difficulty: "medium",
    topic: "假設檢驗",
    hasMath: false
  },
  {
    id: 11,
    question: "一個班級有 30 名學生，隨機選擇 5 名學生的組合數是：",
    questionEn: "A class has 30 students. The number of ways to choose 5 students is:",
    options: ["\\(C(30,5) = 142506\\)", "\\(P(30,5) = 570024\\)", "\\(30 \\times 5 = 150\\)", "\\(\\frac{30!}{5!}\\)"],
    correctAnswer: 0,
    explanation: "組合數公式：\\(C(30,5) = \\frac{30!}{5!(30-5)!} = \\frac{30!}{5! \\times 25!} = 142506\\)",
    explanationEn: "Combination formula: \\(C(30,5) = \\frac{30!}{5!(30-5)!} = \\frac{30!}{5! \\times 25!} = 142506\\)",
    difficulty: "medium",
    topic: "組合",
    hasMath: true
  },
  {
    id: 12,
    question: "二項分佈 B(n, p) 的期望值是：",
    questionEn: "The expected value of binomial distribution B(n, p) is:",
    options: ["\\(np\\)", "\\(np(1-p)\\)", "\\(\\sqrt{np(1-p)}\\)", "\\(n(1-p)\\)"],
    correctAnswer: 0,
    explanation: "二項分佈 B(n, p) 的期望值（平均數）是 \\(E(X) = np\\)",
    explanationEn: "The expected value (mean) of binomial distribution B(n, p) is \\(E(X) = np\\)",
    difficulty: "medium",
    topic: "二項分佈",
    hasMath: true
  },
  {
    id: 13,
    question: "在散點圖中，如果所有數據點都完全落在一條直線上，相關係數 r 的值是：",
    questionEn: "In a scatter plot, if all data points lie exactly on a straight line, the correlation coefficient r is:",
    options: ["r = ±1", "r = 0", "r = 0.5", "無法確定"],
    correctAnswer: 0,
    explanation: "當所有數據點完全落在一條直線上時，相關係數 r = +1（正斜率）或 r = -1（負斜率）",
    explanationEn: "When all data points lie exactly on a straight line, correlation coefficient r = +1 (positive slope) or r = -1 (negative slope)",
    difficulty: "easy",
    topic: "相關性",
    hasMath: false
  },
  {
    id: 14,
    question: "卡方檢驗主要用於檢驗：",
    questionEn: "Chi-square test is primarily used to test:",
    options: ["獨立性和適合度", "平均數差異", "相關性強度", "變異數相等性"],
    correctAnswer: 0,
    explanation: "卡方檢驗主要用於檢驗分類變數之間的獨立性和分佈的適合度",
    explanationEn: "Chi-square test is primarily used to test independence between categorical variables and goodness of fit",
    difficulty: "medium",
    topic: "非參數檢驗",
    hasMath: false
  },
  {
    id: 15,
    question: "樣本標準差的公式是：",
    questionEn: "The formula for sample standard deviation is:",
    options: ["\\(s = \\sqrt{\\frac{\\sum(x_i - \\bar{x})^2}{n-1}}\\)", "\\(s = \\sqrt{\\frac{\\sum(x_i - \\bar{x})^2}{n}}\\)", "\\(s = \\frac{\\sum(x_i - \\bar{x})^2}{n-1}\\)", "\\(s = \\frac{\\sum x_i}{n}\\)"],
    correctAnswer: 0,
    explanation: "樣本標準差使用 n-1 作為分母（貝塞爾修正），公式為 \\(s = \\sqrt{\\frac{\\sum(x_i - \\bar{x})^2}{n-1}}\\)",
    explanationEn: "Sample standard deviation uses n-1 as denominator (Bessel's correction), formula is \\(s = \\sqrt{\\frac{\\sum(x_i - \\bar{x})^2}{n-1}}\\)",
    difficulty: "medium",
    topic: "變異性",
    hasMath: true
  }
  // Additional questions 16-30 would continue with similar complexity covering regression, probability distributions, etc...
]; 